import Vue from 'vue'

export default {
  getPurchaseByOrderNumber (orderNumber) {
    return Vue.prototype.$http.get(`/public_access/purchases/${orderNumber}`)
  }
}
